import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import { getUserSession } from "../../../../core/util/core/Session";
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";

function Form() {

    const session = getUserSession();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const profileFilter = chooseProfileFilter()

    const hiddenValues = {}

    if (profileFilter.pdc_entity_id) {
        hiddenValues.pdc_entity_id = profileFilter.pdc_entity_id
    }

    const path = '/fileemployeepayments/';
    const paths = {
        endpointSave: config.endpoints.backend + 'fileemployeepayments/save',
        endpointGetById: config.endpoints.backend + 'fileemployeepayments/getById',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllIntegrationSystems: config.endpoints.backend + 'integrationsystems/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Importar Folha de Pagamentos",
        labelTitleEdit: "Editar Folha de Pagamento",
        labelTitleView: 'Visualizar Folha de Pagamento'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                ...hiddenValues
            },
            fields: [
                !hiddenValues.pdc_entity_id ? {
                    name: 'pdc_entity_id',
                    type: 'select',
                    label: 'Entidade - Com Empregados Importados',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllEntities,
                        label: 'corporate_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                hasEmployees: true
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                } : {},
                {
                    name: 'pdc_integration_system_id',
                    type: 'select',
                    label: 'Sistema - Integração',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllIntegrationSystems,
                        label: 'name',
                        value: 'id',
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                    canAutoFill: true
                },
                {
                    name: 'file',
                    type: 'file',
                    label: 'Arquivo TXT de folha de pagamentos',
                    extensionAccept: '.txt',
                    validations: {
                        required: true
                    },
                    limitFileSize: 15,
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
